module.exports = __webpack_public_path__ + "img/list.e1cec835.svg";